import React from "react";

interface StudioTagProps {
  studioSlug: string;
  studioName?: string;
  className?: string;
}

// Revision 1.1.5 item 1: one style token for every studio. The owner liked the
// Pererenan chip best and asked for it to become the standard for all four, brightened.
// The old per-studio palette (legian #365f85, berawa #506531, sanur #715c09,
// pererenan #84979e) is gone: every slug now shares this single token, so a new studio
// needs no colour decision.
//
// The tint is a light, opaque shade of the old Pererenan grey-blue so the chip stays
// legible on top of a card photo, and the text is dark enough to hold contrast: #2f3b44
// on #eef3f6 measures ~10.3:1, comfortably above the WCAG AA 4.5:1 minimum for body text.
const STUDIO_TAG_CLASSES = "bg-[#eef3f6] text-[#2f3b44] border-[#84979e]/40";

export const StudioTag: React.FC<StudioTagProps> = ({
  studioSlug,
  studioName,
  className = "",
}) => {
  const slug = studioSlug.toLowerCase();
  let displayName = studioName;
  if (!displayName) {
    if (slug === "legian") displayName = "Legian";
    else if (slug === "berawa") displayName = "Berawa";
    else if (slug === "sanur") displayName = "Sanur";
    else if (slug === "pererenan") displayName = "Pererenan";
    else displayName = studioSlug;
  }

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold tracking-wide border shadow-sm ${STUDIO_TAG_CLASSES} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current mr-1.5 opacity-70" />
      {displayName}
    </span>
  );
};
